module.exports = __webpack_public_path__ + "static/media/kiera-knightly-lose.1d73a14f.jpg";